/* RESPONSIBLE TEAM: team-frontend-tech */
import TextBlock from './text-block';

export default TextBlock.extend({});
